import { useMemo } from "react";
import PropTypes from "prop-types";
import { getScoreColor } from "../utils/colorScales";

export default function ScoreBar({ score, label, showValue = true, height = 8 }) {
  const { color, bgColor } = useMemo(() => getScoreColor(score), [score]);

  return (
    <div className="space-y-2">
      {(label || showValue) && (
        <div className="flex justify-between items-center">
          {label && <span className="text-sm text-navy-300">{label}</span>}
          {showValue && (
            <span className="text-sm font-semibold font-mono" style={{ color }}>
              {score?.toFixed?.(1) ?? "--"}
            </span>
          )}
        </div>
      )}
      <div className="rounded-full overflow-hidden" style={{ height, backgroundColor: "rgba(255,255,255,0.05)" }}>
        <div
          className="h-full rounded-full transition-all duration-1000 ease-out"
          style={{
            width: `${Math.min(100, Math.max(0, score || 0))}%`,
            backgroundColor: color,
            boxShadow: `0 0 10px ${bgColor}`,
          }}
        />
      </div>
    </div>
  );
}

ScoreBar.propTypes = {
  score: PropTypes.number,
  label: PropTypes.string,
  showValue: PropTypes.bool,
  height: PropTypes.number,
};
